export default class FormFileUpload {
	static init() {
		document.addEventListener("change", event => {
			const input = event.target.closest(".gform_wrapper .ginput_container_fileupload input[type='file']");
			if (!input) return;

			this.updateState(input);
		});

		document.addEventListener("click", event => {
			const button = event.target.closest(".gform_wrapper .gfield_fileupload_remove");
			if (!button) return;

			event.preventDefault();

			const input = button.closest(".ginput_container_fileupload").querySelector("input[type='file']");
			input.value = "";
			this.updateState(input);
		});
	}

	static updateState(input) {
		const container = input.closest(".ginput_container_fileupload");
		const hasFile = input.files.length > 0;

		container.classList.toggle("has-file", hasFile);

		let button = container.querySelector(".gfield_fileupload_remove");
		if (!button) {
			button = document.createElement("button");
			button.type = "button";
			button.className = "gfield_fileupload_remove";
			button.setAttribute("aria-label", "Supprimer le fichier");
			input.insertAdjacentElement("afterend", button);
		}
		button.hidden = !hasFile;
	}
}
